import { render, staticRenderFns } from "./KakusanScreen.vue?vue&type=template&id=c4dc6fd0&"
import script from "./KakusanScreen.vue?vue&type=script&lang=js&"
export * from "./KakusanScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports